import PortalIdParser from 'PortalIdParser';
export const ACCOUNT_CURRENCIES_URL = `/settings/${PortalIdParser.get()}/account-defaults/multicurrency`;